import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

const WebSocketComponent = () => {
  const [messageLog, setMessageLog] = useState([]);
  const [connectionStatus, setConnectionStatus] = useState(false);
  const [socketUrl, setSocketUrl] = useState("");
  const [isListening, setIsListening] = useState(false); // New state to control listening
  const audioContext = useRef(null); // Web Audio API
  //console.log("audioContext", audioContext);
  const sourceNode = useRef(null); // Audio source node for playback

  const audioQueue = useRef([]); // Queue for storing audio data
  //console.log("audioQueue", audioQueue);

  const initiateCall = async () => {
    try {
      const response = await axios.post(
        "https://azzportal.com/dev/public/api/v3/assistant_api/create-call",
        {
          phone: "+923090851306",
          variable_values: {
            name: "Muhammad Zaheer",
            provider_name: "Muhammad Ramzan",
            start_time: "2024-12-20T10:30:00-05:00",
            appointment_id: "10121149281879341231211",
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer 712|DWXc6oxxXHcpxdT79WDSECsXIulZXzG4M7lYbI7Y59cd0b4f`,
          },
        }
      );
      setSocketUrl(response.data.monitor.listenUrl);
    } catch (error) {
      console.error("Error initiating call:", error);
    }
  };

  useEffect(() => {
    let ws;
    let retryCount = 0;
    const maxRetries = 10;

    const setupWebSocket = () => {
      if (!socketUrl) return;

      ws = new WebSocket(socketUrl);

      ws.onopen = () => {
        setConnectionStatus(true);
        retryCount = 0;
        setSocketUrl("");
      };

      ws.onmessage = (event) => {
        if (event.data instanceof Blob) {
          console.log("event data", event.data);
          const reader = new FileReader();
          console.log("reader", reader);

          reader.onload = () => {
            const arrayBuffer = new Uint8Array(reader.result);
            console.log("array buffer", arrayBuffer);
            // Append the PCM data to the queue and process it
            audioQueue.current.push(arrayBuffer);

            if (isListening) processAudioQueue(); // Only process if listening is active
          };

          reader.readAsArrayBuffer(event.data);
        } else {
          try {
            const parsedMessage = JSON.parse(event.data);
            setMessageLog((prevMessages) => [...prevMessages, parsedMessage]);
          } catch (error) {
            console.error("Error parsing WebSocket message:", error);
          }
        }
      };
      ws.onclose = () => {
        console.error("WebSocket closed");
        setConnectionStatus(false);
        retryWebSocketConnection();
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        ws.close();
      };
    };

    const retryWebSocketConnection = () => {
      if (retryCount < maxRetries) {
        setTimeout(() => {
          retryCount++;
          console.log(`Retrying WebSocket connection: Attempt ${retryCount}`);
          setupWebSocket();
        }, 2000);
      } else {
        console.warn(
          "Maximum retry attempts reached. Stopping retries for this URL."
        );
      }
    };

    if (socketUrl && !connectionStatus) {
      setupWebSocket();
    }

    return () => {
      if (ws) ws.close();
    };
  }, [socketUrl, connectionStatus, isListening]);

  const convertPcmToWav = (pcmData, sampleRate = 16000, channels = 2) => {
    const header = new ArrayBuffer(44);
    const view = new DataView(header);

    const writeHeaderString = (offset, str) => {
      for (let i = 0; i < str.length; i++) {
        view.setUint8(offset + i, str.charCodeAt(i));
      }
    };

    writeHeaderString(0, "RIFF");
    view.setUint32(4, 36 + pcmData.length, true);
    writeHeaderString(8, "WAVE");
    writeHeaderString(12, "fmt ");
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, channels, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * channels * 2, true);
    view.setUint16(32, channels * 2, true);
    view.setUint16(34, 16, true);
    writeHeaderString(36, "data");
    view.setUint32(40, pcmData.length, true);

    const wavBuffer = new Uint8Array(header.byteLength + pcmData.length);
    wavBuffer.set(new Uint8Array(header));
    wavBuffer.set(pcmData, header.byteLength);

    return wavBuffer;
  };

  // const processAudioQueue = () => {
  //   if (!audioContext.current) {
  //     audioContext.current = new AudioContext();
  //   }

  //   if (audioQueue.current.length > 0) {
  //     const pcmData = audioQueue.current.shift();
  //     const wavFile = convertPcmToWav(pcmData);

  //     // Create a Blob URL for the WAV file
  //     const blob = new Blob([wavFile], { type: "audio/wav" });
  //     const wavUrl = URL.createObjectURL(blob);

  //     // Create an audio element for playback
  //     const audioElement = new Audio(wavUrl);

  //     // Play the audio
  //     audioElement.play();

  //     // When playback ends, process the next item in the queue
  //     audioElement.onended = () => {
  //       setTimeout(processAudioQueue, 0);
  //     };
  //   }
  // };
  const processAudioQueue = async () => {
    if (!audioContext.current) {
      audioContext.current = new AudioContext();
    }

    while (audioQueue.current.length > 0) {
      const pcmData = audioQueue.current.shift();

      // Convert PCM to WAV
      const wavFile = convertPcmToWav(pcmData);

      // Decode WAV to audio buffer for seamless playback
      const audioBuffer = await audioContext.current.decodeAudioData(
        wavFile.buffer
      );

      // Create a source node
      const sourceNode = audioContext.current.createBufferSource();
      sourceNode.buffer = audioBuffer;

      // Optional: Add gain node for volume control
      const gainNode = audioContext.current.createGain();
      gainNode.gain.value = 1.0; // Adjust this value for volume

      sourceNode.connect(gainNode);
      gainNode.connect(audioContext.current.destination);

      // Play the audio
      sourceNode.start();

      // Wait until the current audio is done playing before processing the next
      await new Promise((resolve) => {
        sourceNode.onended = resolve;
      });
    }
  };

  const handleStartListening = () => {
    setIsListening(true); // Start listening for audio
    processAudioQueue(); // Begin processing the queue immediately
  };

  return (
    <div className="flex flex-col items-start p-10">
      <button onClick={initiateCall} className="bg-red-400 py-2 px-2 rounded">
        Initiate Call
      </button>
      <h2>WebSocket Status</h2>
      <p>{connectionStatus ? "Connected" : "Disconnected"}</p>

      <h3>Messages</h3>
      <ul>
        {messageLog.map((msg, index) => (
          <li key={index}>{JSON.stringify(msg)}</li>
        ))}
      </ul>

      <div className="flex gap-4">
        {/* Start Listening button */}
        <button
          className="bg-green-500 p-2 rounded-md"
          onClick={handleStartListening}
        >
          Start Listening
        </button>
      </div>
    </div>
  );
};

export default WebSocketComponent;
